// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { Util } from 'app/scripts/lib/util';
import { DragSort } from 'app/scripts/views/lib/DragSort';

export const openListComposer = function () {
  return this.model.viewState.openListComposer();
};

export const scrollToList = function (list) {
  Util.scrollElementIntoView(
    this.el.querySelector('#board'),
    this.viewForList(list).el,
    {
      horizontal: true,
      animated: true,
    },
  );
};

export const viewForList = function (list) {
  return this.listListView.viewForModel(list);
};

export const postListListRender = function () {
  this.renderFilteringStatus();
  return DragSort.refreshListCardSortable();
};

export const renderLists = function () {
  this.listListView.$el.toggleClass('js-list-sortable', this.model.editable());
  $('.board-canvas', this.$el).append(this.listListView.el);
  // Render after adding because postListListRender is dumb and wants the
  // #board element to be in the DOM already
  this.listListView.render();
  this.listListView.delegateEvents();
  return this;
};

export const sortCommit = (e, ui) => ui.item.trigger('movelist', ui);
